export default "__VITE_ASSET__f6GMb61W__"